import { Box } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { ByzMuiDateTimePicker } from "src/components/core-components/mui/inputs/ByzMuiDateTimePicker";
import ByzMuiSelect from "src/components/core-components/mui/ByzMuiSelect";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import { useTranslate } from "src/locales/use-locales";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";

function EmaSepsisScoreCreate({ patient }: { patient: any }) {
  const { t } = useTranslate();

  const renderLabelAndField = (label: string, input: React.ReactNode) => (
    <Grid container alignItems="center" justifyContent="space-between">
      <Grid xs={12} md={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
        <ByzMuiTypography  >
          {label}
        </ByzMuiTypography>
      </Grid>
      <Grid xs={12} md={6}>
        {input}
      </Grid>
    </Grid>
  );

  const selectField = (label: string) =>
    renderLabelAndField(
      label,
      <ByzMuiSelect
        renderInput={(params) => (
          <ByzMuiTextField {...params} label={label} variant="outlined" fullWidth />
        )}
        fullWidth
        options={[]}
        placeholder={t('buttons.chose')}
        label={""} />
    );

  const typographyField = (label: string) =>
    renderLabelAndField(label, <ByzMuiTypography>{label}</ByzMuiTypography>);

  const dateTimeField = (label: string) =>
    renderLabelAndField(label, <ByzMuiDateTimePicker />);

  return (
    <Box sx={{ padding: 3, width: "100%" }}>
      <Box sx={{ mb: 2 }}>
        <ByzMuiTypography >
          {t('ema-sepsis.patient')}: {patient?.fullName}
        </ByzMuiTypography>
      </Box>

      <Grid container spacing={2}>
        <Grid xs={12} md={6} container direction="column" spacing={3}>
          <Grid xs={12} sx={{ backgroundColor: "#F4F7FE", borderBottom: "1px solid #E0E0E0" }}>
            <ByzMuiTypography >
              {t('ema-sepsis.score-form')}
            </ByzMuiTypography>
          </Grid>

          {dateTimeField(t('datetime'))}


          {selectField(t('createdby'))}

          <Grid xs={12} sx={{ backgroundColor: "#F4F7FE" }}>
            <ByzMuiTypography  >
              {t('ema-sepsis.clinical-finding')}
            </ByzMuiTypography>
          </Grid>

          {selectField(t('ema-sepsis.clinical-findings.body-temperature'))}
          {selectField(t('ema-sepsis.clinical-findings.cardiovascular'))}
          {selectField(t('ema-sepsis.clinical-findings.skin-and-subcutaneous-lesions'))}
          {selectField(t('ema-sepsis.clinical-findings.respiratory'))}
          {selectField(t('ema-sepsis.clinical-findings.gastrointestinal'))}
          {selectField(t('ema-sepsis.clinical-findings.non-specific'))}

          <Grid xs={12} sx={{ backgroundColor: "#F4F7FE" }}>
            <ByzMuiTypography >
              {t('ema-sepsis.laboratory-finding')}
            </ByzMuiTypography>
          </Grid>

          {selectField(t('ema-sepsis.laboratory-findings.wbc-count'))}
          {selectField(t('ema-sepsis.laboratory-findings.immature-neutrophil-ratio'))}
          {selectField(t('ema-sepsis.laboratory-findings.platelet-count'))}
          {selectField(t('ema-sepsis.laboratory-findings.crp'))}
          {selectField(t('ema-sepsis.laboratory-findings.procalcitonin'))}
          {selectField(t('ema-sepsis.laboratory-findings.metabolic-acidosis'))}

          <Grid xs={12} sx={{ backgroundColor: "#F4F7FE" }}>
            <ByzMuiTypography  >
              {t('ema-sepsis.blood-sugar-monitor')}
            </ByzMuiTypography>
          </Grid>

          {selectField(t('ema-sepsis.blood-sugar-monitoring.hyperglycemia'))}
          {selectField(t('ema-sepsis.blood-sugar-monitoring.hypoglycemia'))}

          <Grid xs={12} sx={{ backgroundColor: "#F4F7FE" }}>
            <ByzMuiTypography  >
              {t('other')}
            </ByzMuiTypography>
          </Grid>

          {selectField(t('ema-sepsis.other.blood-culture'))}

          {selectField(t('ema-sepsis.other.score'))}
        </Grid>
      </Grid>
    </Box>
  );
}

export default EmaSepsisScoreCreate;